import { useState } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from 'react-router-dom';

import './styles.css';

import Header from './components/header';
import ProgressBar from './components/progress-bar';
import Demographics from './routes/demographics';
import DetailedResults from './routes/detailed-results';
import Device from './routes/device';
import Environment from './routes/environment';
import Headphones from './routes/headphones';
import Home from './routes/home';
import Instructions from './routes/instructions';
import Results from './routes/results';
import Feedback from './routes/feedback';
import Test from './routes/test';

import { TestProvider } from './context/TestContext';
import EarHistory from './routes/ear-history';
import Soundcard from './routes/soundcard';
import { useTrackingInitialization } from './hooks/useTrackingInitialization';

function App() {
  // Initialize tracking on app mount
  useTrackingInitialization();

  // key for hiding buttons when user is linked from partner site
  const queryParams = new URLSearchParams(window.location.search);
  const [isB2b2c] = useState(!!(queryParams.get('utm_source') === 'b2b2c'));
  const [rht] = useState(!!queryParams.get('rht') || false);

  // can be passed to test, or wherever we need it
  const [b2b] = useState(!!queryParams.get('b2b') || false);
  const localHearingOnly = process.env.REACT_APP_LOCAL_HEARING_ONLY === 'true';

  return (
    <main className="top-container">
      <TestProvider>
        <Router>
          <Header />
          <ProgressBar />

          <Routes>
            <Route
              path="/"
              element={
                localHearingOnly ? (
                  <Navigate to="/test" replace />
                ) : (
                  <Home rht={rht} isB2b={b2b} isB2b2c={isB2b2c} />
                )
              }
            />

            {/* B2B ONLY ROUTES */}
            <Route path="/earhistory" element={<EarHistory />} />
            <Route path="/soundcard" element={<Soundcard />} />

            <Route path="/demographics" element={<Demographics rht={rht} />} />

            <Route path="/device" element={<Device />} />
            <Route path="/environment" element={<Environment isB2b={b2b} />} />
            <Route path="/headphones" element={<Headphones isB2b={b2b} />} />
            <Route path="/instructions" element={<Instructions />} />

            <Route
              path="/test"
              element={<Test isB2b2c={isB2b2c} isB2b={b2b} />}
            />

            <Route
              path="/feedback"
              element={<Feedback isB2b2c={isB2b2c} isB2b={b2b} rht={rht} />}
            />

            <Route
              path="/results"
              element={<Results isB2b2c={isB2b2c} isB2b={b2b} rht={rht} />}
            />

            <Route
              path="/results/detailedresults"
              element={<DetailedResults />}
            />

            {/* ZMTODO: Add notfound handling to redirect to home if route not found */}
          </Routes>
        </Router>
      </TestProvider>
    </main>
  );
}

export default App;
